import { apiKey } from "./Helper";

// Singleton loader for the Google Maps JS API. Loading the SDK more than once on
// a page is unsupported and corrupts its internals (e.g. "undefined is not an
// object (evaluating 'p.kK')"). Every map component must go through this so the
// script is injected exactly once and everyone shares the same promise.
//
// Pinned to v=3.64: google.maps.drawing.DrawingManager was removed in v3.65.
// TODO: replace DrawingManager with a custom polygon drawer to drop this pin.
let mapsPromise = null;

export const loadGoogleMaps = () => {
  if (mapsPromise) return mapsPromise;

  // already present (e.g. loaded by a prior mount)
  if (window.google && window.google.maps) {
    mapsPromise = Promise.resolve(window.google);
    return mapsPromise;
  }

  mapsPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById("gmaps-sdk");
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google));
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.id = "gmaps-sdk";
    script.async = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=drawing&v=3.64`;
    script.onload = () => resolve(window.google);
    script.onerror = reject;
    document.body.appendChild(script);
  });

  return mapsPromise;
};

export default loadGoogleMaps;
